import styled from 'styled-components'

import { Box, Button, Text } from '@usap/uicomponents'

export const ShippingModalContainer = styled(Box)`
  gap: 20px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 500px;
  }
`

export const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledH3 = styled('h3')`
  color: #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 165%;
  margin: 0;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    font-size: 24px;
  }
`

export const StyledP = styled('p')`
  color: #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
`

export const ShippingFormContainer = styled('div')`
  display: flex;
  height: 48px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const ShippingSubmit = styled(Button)`
  display: flex;
  width: 132px;
  height: 48px;
  margin-top: 6px;
  padding: 0px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #FFCD05;
  color: #282832;
  text-align: center;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;

  &:disabled {
    background: #c9c9cc;
    opacity: 1;
    color: #7e7e84;
  }
`

export const ShippingFormFootnotes = styled.span`
  color: #5E5E65;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const FormAndMessageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ErrorMessage = styled(Text)`
  display: flex;
  font-size: 12px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  color: #C33;
  margin-left: 4px;
  margin-top: 2px;
`
